import { render } from "./address-comp.vue?vue&type=template&id=a33af5d6&scoped=true"
import script from "./address-comp.vue?vue&type=script&lang=js"
export * from "./address-comp.vue?vue&type=script&lang=js"

import "./address-comp.vue?vue&type=style&index=0&id=a33af5d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a33af5d6"]])

export default __exports__